import cart from '../helpers/cart-helper'
import refs from '../helpers/refs'
import TabTrap from '../helpers/tab-trap'

class MSlideOutCart {
  constructor (slideOutCart) {
    this.slideOutCart = slideOutCart
    this.$refs = refs(this.slideOutCart)
    this.showing = false

    this.tabTrap = new TabTrap(this.slideOutCart)

    this.init()
  }

  init () {
    // Close button
    this.$refs.closeSlideOutCart.addEventListener(
      'click',
      this.hide.bind(this)
    )

    this.initCartItemEventHandlers()

    // Event handlers
    document.addEventListener('cart:show', this.show.bind(this))
    document.addEventListener('cart:hide', this.hide.bind(this))
    document.addEventListener('cart:toggle', this.toggle.bind(this))
    document.addEventListener('cart:updated', this.renderCart.bind(this))
  }

  show () {
    this.showing = true
    this.slideOutCart.classList.remove('hidden')
    this.tabTrap.initEvents()
  }

  hide () {
    this.showing = false
    this.slideOutCart.classList.add('hidden')
    this.tabTrap.destroyEvents()
  }

  toggle () {
    if (this.showing) {
      this.hide()
    } else {
      this.show()
    }
  }

  renderCart () {
    cart.getCart().then((cart) => {
      // Update heading depending on if cart is empty or not
      this.$refs.slideOutCartHeading.innerText =
        cart.item_count > 0 ? 'Added to cart.' : 'Your cart is empty.'

      // Clear container
      const container = document.querySelector('[data-m-cart-list-container]')

      // Render new HTML
      const newHTML = cart.items
        .map((item, index) =>
          this.productHTML(
            item.title,
            item.id,
            item.url,
            item.image,
            item.price,
            item.quantity,
            index,
            item.key,
            item.sku,
            item.handle
          )
        )
        .join('')
      // On item remove the HTML is updated
      // So, we don't always have to replace the HTML
      // By not replacing the HTML we can avoid flickering
      if (container.innerHTML !== newHTML) {
        container.innerHTML = newHTML
      }

      // Re-init slideOut cart item event handlers
      this.initCartItemEventHandlers()
      document.dispatchEvent(
        new CustomEvent('cartItems:updated', { detail: cart })
      )

      // show/hide free shipping info
      if (this.$refs.freeshipping) {
        const freeshipping = cart.items_subtotal_price > this.$refs.freeshipping.dataset.minimum
        this.$refs.freeshipping.children[0].classList.toggle('hidden', !freeshipping)
        this.$refs.freeshipping.children[1].classList.toggle('hidden', freeshipping)
      }

      // Set cart total
      this.$refs.subtotalPrice.innerText = `$${(
        cart.items_subtotal_price / 100
      ).toFixed(2)}`

      // Set view cart button
      const viewCartBtn = this.$refs.viewCartButton
      const innerElem =
        viewCartBtn.children.length > 0 ? viewCartBtn.children[0] : viewCartBtn
      innerElem.innerText = `View Cart (${cart.item_count})`
    })
  }

  productHTML (
    title,
    productID,
    productURL,
    imgURL,
    price,
    quantity,
    line,
    key,
    sku,
    handle
  ) {
    // Copy-pasted from browser HTML
    return `<li class="border-b border-smoke-dark flex items-center py-6 lg:py-10 w-full" ref="cartItem" data-item-key="${key}">
        <a class="block flex-shrink-0 mr-4 lg:mr-8 w-18 h-18 lg:w-30 lg:h-30" href="${productURL}" aria-hidden="true">
          <figure class="o-aspect-ratio">
            <img alt="${title}" class="o-aspect-ratio__content object-cover" height="200" loading="lazy" src="${imgURL}" width="200" aria-hidden="true">
          </figure>
        </a>

        <div class="w-full">
          <div class="flex items-start justify-between mb-4">
            <a class="text-body-3" href="${productURL}">
              ${title}
            </a>

            <p class="ml-4 lg:ml-8 text-number-1 lg:text-number-2">
              <span class="sr-only">Price: </span>$${(price / 100).toFixed(2)}
            </p>
          </div>

          <div class="flex items-center">
            <span class="font-bold text-label-1 uppercase">
              Quantity
            </span>

            ${
  /* <select ref="update" class="a-select ml-3" data-product-id="${productID}">
                ${[...Array(Math.max(5, quantity)).keys()].map(index => `<option ${index === (quantity - 1) ? 'selected' : ''} value="${index + 1}" >
                  ${index + 1}
                </option>`)}
            </select> */ ''
            }
            <p class="ml-3 font-bold">
              ${quantity}
            </p>
            <span class="lg:hidden w-full"></span>

            <button ref="remove" class="font-bold ml-8 text-label-1 text-black underline uppercase" data-product-id="${productID}" data-product-handle="${handle}" data-product-sku="${sku}" data-product-qty="${quantity}">
              Remove
            </button>
          </div>
        </div>
      </li>`
  }

  initCartItemEventHandlers () {
    for (const item of this.slideOutCart.querySelectorAll('[ref="cartItem"]')) {
      const remove = item.querySelector('[ref="remove"]')

      remove.addEventListener('click', (event) => {
        item.parentNode.removeChild(item)

        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            updates: {
              [item.dataset.itemKey]: 0
            }
          })
        })
          .then(response => response.json())
          .then((newCart) => {
            // console.log('Cart updated cart:', newCart)

            cart.cartUpdated(newCart)
          })
          .catch(console.error)
      })
    }
  }
}

// On DOM Content Loaded
document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('[data-m-slide-out-cart]')
    .forEach(el => new MSlideOutCart(el))
})
